import {
    CustomTableCheck,
    CustomLoading
} from "../../../../../../../common";

export const PaymentTable = ({ useFetchInit }) => {

    const {
        FetchData,
        globalStates,
        Helpers,
        Forms,
        Actions
    } = useFetchInit

    const { formOpeningMode } = globalStates
    const { getPreviousMonthDate, getCurrentDate } = Helpers

    const { FormRequestGlobal } = Forms
    const { formState } = FormRequestGlobal

    const { fetchCreditPayments, fetchTransactionsByPayment } = FetchData
    const { dataCreditPayments, loadingFetchCreditPayments } = fetchCreditPayments
    const { loadingFetchTransactionsByPayment } = fetchTransactionsByPayment

    const { handleClickFetchTransactionsByPayment } = Actions

    const fecha_actual = getCurrentDate();

    const isReadOnly = (formOpeningMode==='READONLY')

    const dataToShow = isReadOnly
        ? formState.payments
        : dataCreditPayments
    
    const columnConfig = [
        {
            headerName: '',
            width: 60,
            checkboxSelection: !isReadOnly, // bloquea checks para mosodo read-only.
            headerCheckboxSelection: !isReadOnly, // bloquea checks para mosodo read-only.
            pinned: 'left',
            suppressMenu: true,
            sortable: false,
            filter: false,
            resizable: false
        },
        { field: "no_cuota", headerName: "NO. CUOTA", maxWidth: 130, minWidth: 130, filter: true },
        { field: "fecha_pago", headerName: "FECHA", maxWidth: 120, minWidth: 120, filter: true },
        { field: "cuota_niv", headerName: "CUOTA", maxWidth: 120, minWidth: 120, filter: true },
        { field: "seguro", headerName: "SEGURO", maxWidth: 120, minWidth: 120, filter: true },
        { field: "gps", headerName: "GPS", maxWidth: 120, minWidth: 120, filter: true },
        { field: "otros", headerName: "OTROS", maxWidth: 120, minWidth: 120, filter: true },
        { field: "intereses", headerName: "INTERESES", maxWidth: 130, minWidth: 130, filter: true, },
        { field: "amortizacion", headerName: "AMORTIZACION", maxWidth: 130, minWidth: 130, filter: true, },
        { field: "exoneracion", headerName: "EXONERACION", maxWidth: 130, minWidth: 130, filter: true,},
        { field: "mora_f", headerName: "MORA", maxWidth: 120, minWidth: 120, filter: true, },
        { field: "total_abonado", headerName: "ABONADO", maxWidth: 140, minWidth: 140, filter: true, },
        { field: "abono_capital", headerName: "A. CAPITAL", maxWidth: 140, minWidth: 140, filter: true, },
        { field: "cuota_pagar", headerName: "CUOTA TOTAL", maxWidth: 150, minWidth: 150, filter: true },
        {
            field: "dias_atraso_totales_f",
            headerName: "DIAS DE ATRASO",
            maxWidth: 160,
            minWidth: 160,
            filter: true,
            cellClass: (params) => {
                if ((params.value > 0)) return 'bg-danger';
                return 'bg-success';
            },
        },

        {
            field: "total_pagar_f", headerName: "TOTAL A PAGAR", maxWidth: 180, minWidth: 180, filter: true,
            cellRenderer: (params) => {
                return (parseFloat(params.value) > 0) ? `Q. ${params.value}` : `Q. ${0}`
            },
            cellClass: (params) => {
                if (parseFloat(params.value) > 0) return 'bg-danger';
                    return 'bg-success';
            },
        }
    ];

    const gridOptions = {
        getRowStyle: (params) => {
            const fecha_inicial = getPreviousMonthDate(params.data.fecha_pago)
            if ((fecha_actual > fecha_inicial) && (fecha_actual <= params.data.fecha_pago))
                return { backgroundColor: '#D9D9D9' };

        }
    };

    return (
        <>
            {(loadingFetchTransactionsByPayment || loadingFetchCreditPayments) && (<CustomLoading/>)}
            <CustomTableCheck
                rowConfig={dataToShow}
                columnConfig={columnConfig}
                gridOptions={gridOptions}
                rowSelection={'single'}
                // handleClicks
                onRowSelected={
                    (event)=>handleClickFetchTransactionsByPayment({
                        target: { 
                            name: 'rowSelectedPayments', 
                            value: event.api.getSelectedRows(),
                        }
                    })
                }
                // onRowSelected={handleRowSelected}
            />
        </>
    );
}
